import * as types from '../constants'

import API_USER from '@api/user'

export const updateUser = payload => ({
  type: types.UPDATE_USER,
  payload,
})

export const updateIP = payload => ({
  type: types.UPDATE_IP,
  payload,
})

export const getIP = () => (dispatch) => {
  return API_USER.getIP().then((response) => {
    dispatch(updateIP(response.data.ip))
  })
}



// WEBPACK FOOTER //
// ./src/store/user/actions.js